<template>
    <div class="mh-card-subheader" @click="action" :class="{'clickable': clickable}">
        <div class="icon"><i class="far fa-fw" :class="icon" v-if="icon"></i></div>
        <div class="title">{{title}}</div>
        <div class="indicator" v-if="badge"><b-badge variant="light" class="badge-label">{{badge}}</b-badge></div>
    </div>
</template>

<script>
    export default {
        name: 'CardSubheader',
        props: {
            title:  String,
            icon: String,
            badge: String,
            clickable: Boolean
        },
        methods: {
            action: function() {
                if (this.clickable) this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    $color: #5d7286;

    .mh-card-subheader {
        background-color: $color !important;
        padding: 0.2rem 0 !important;

        display: flex;
        color: white;
        cursor: auto !important;

        .title {
            font-family: 'Montserrat', sans-serif;
            text-transform: uppercase;
            font-size: 0.75rem !important;
            font-weight: bold;
            letter-spacing: 0.5px;
            padding: 5px 0 3px;
        }

        .badge-label, .badge-column {
            font-size: 0.67rem;
            color: #504f4f !important;
        }

        &.clickable {
            cursor: pointer;
        }

        .icon {
            /*background-color: lighten(red, 40);*/
            min-width: 18px;
            text-align: center;
            margin-right: 10px;
            margin-left: 12px;

            i {
                font-size: 0.8rem !important;
            }
        }
    }
</style>
